// extracted by mini-css-extract-plugin
export var dataCell = "_oi-2";
export var dataRow = "_oi-0";
export var headerRow = "_oi-1";